const REASON_FOR_ENCOUNTER_MAX_LENGTH = 1000
export { REASON_FOR_ENCOUNTER_MAX_LENGTH }
